import useAuth from "./useAuth";

const useLogout = () => {
  const { setAuth, setPersist } = useAuth();

  const logout = () => {
    // Clear auth state
    setAuth({});

    // Clear stored tokens/auth data
    localStorage.removeItem('accessToken');
    localStorage.removeItem('auth');

    // Disable persist
    localStorage.setItem('persist', 'false');
    setPersist(false);
  };

  return logout;
};

export default useLogout;